module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qcirc12-13e0c79b2683d99eaa2265765061cdb4.jpg";